// @flow

// useHidingCarouselIndicator is a very narrow hook that mostly encapsulates
// some timer logic. When a Carousel Pin is shown in the grid, a
// PinTypeIndicator displays its current index. So it doesn't obstruct content,
// this indicator is expected to hide after a time delay and only show again
// when the user advances the index.

import { useRef, useState, useEffect } from 'react';
import { type Pin } from 'app/common/react/components/PinRep/types';

const HIDE_TIMEOUT = 4000;

// TODO (rjames): tests for this function
export default function useHidingCarouselIndicator(pin: Pin, isFirstRender: boolean): boolean {
  const { carousel_data: carouselData } = pin;
  const { index } = carouselData || {};

  const [visible, setVisible] = useState(carouselData ? isFirstRender : true);

  const indexRef = useRef(index);
  const timeoutRef = useRef(null);

  if (carouselData) {
    const prevIndex = indexRef.current;
    indexRef.current = index;

    if (index !== prevIndex || isFirstRender) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      setVisible(true);

      timeoutRef.current = setTimeout(() => {
        setVisible(false);
        timeoutRef.current = null;
      }, HIDE_TIMEOUT);
    }
  }

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    [],
  );

  return visible;
}
